///ts:ref=PandaConsole
/// <reference path="../console/PandaConsole.ts"/> ///ts:ref:generated
namespace PerfUtils {
	export function wasteMilliseconds(ms:number):number {
		let start = performance.now();
		let delta = 0;
		let counter = 0;
		while ((delta = performance.now() - start) < ms) {
			counter++;
		}
		//PandaConsole.logDebug('wasteMilliseconds:', counter/delta, 'c/ms');
		return delta;
	}

	export var storage:{[key:string]:{[key:string]:number}} = {};
	export function event(areaName:string, eventName:string, delta:number = 1):void {
		let areaStorage: {[key:string]:number} = storage[areaName];
		if (!areaStorage) {
			areaStorage = {};
			storage[areaName] = areaStorage;
		}
		areaStorage[eventName] = (areaStorage[eventName] || 0) + delta;
	}

}